<!--

-->

<div id="">
   <header id="banner" role="banner">
     <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li class="last"><span><a href="/sirang/">HOME</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
      </div>
      <div class="columns-3" id="main-content" role="main">
         <div class="portlet-layout" id="aui_3_4_0_1_791">
<!--column-1-->
            <div class="aui-w33 portlet-column portlet-3column-first" id="column-1">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-first" id="layout-column_column-1">

                  <div class="sameheight portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_CHBin9jw484W_">
                     <span id="p_56_INSTANCE_CHBin9jw484W"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_CHBin9jw484W">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text"><a href="{{env.login_url}}">Accedi al SIRA</a></span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <p>Accedendo alla parte privata di questo sito cittadini e imprese possono presentare telematicamente un procedimento ambientale gestito nel SIRA (Sistema informativo regionale ambientale) utilizzando il modulo GPA (Gestione procedimenti amministrativi). L’accesso può avvenire tramite autenticazione con SPID (Sistema Pubblico di Identità Digitale) oppure con una CNS (Carta Nazionale dei Servizi) attiva. I procedimenti gestiti: autorizzazioni, concessioni, iscrizioni ad elenchi ecc. sono relativi alle aree tematiche ambientali acque, agenti fisici, aria, suolo, energia, rifiuti e conservazione della natura e valutazioni ambientali. Dopo l’invio è possibile verificare lo stato di avanzamento della pratica, ricevere notifiche e documenti generati nell’ambito del procedimento.</p>
                                       <!--
                                       <div style="padding: 15px; margin: 10px;"> 
                                          <a href="https://test.sardegnasira.it/web/guest/autoregistrazione" target="_self" title="Procedura di autoregistrazione">REGISTRAZIONE</a>
                                       </div>
                                       -->
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>

                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_uEBYRuN5PJqd_">
                     <span id="p_56_INSTANCE_uEBYRuN5PJqd"></span> 
                     <div class="portlet-body">

                        <section class="portlet" id="portlet_56_INSTANCE_cag4mfzejIfx">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text">Contattaci</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <div>
                                          <p> <span style=""><span style="color:#000000;">Il </span><strong><span>S</span></strong><span style="color:#000000;">istema </span><strong><span>I</span></strong><span style="color:#000000;">nformativo </span><strong><span>R</span></strong><span style="color:#000000;">egionale </span><strong><span>A</span></strong><span style="color:#000000;">mbientale prevede un servizio di <strong><i>contatto diretto</i></strong> a disposizione dei suoi utenti. </span></span></p>
                                          <p> <span style=""><span style="color:#000000;">Il servizio offre servizi informativi e di supporto per problemi riscontrati sia sul funzionamento dei moduli applicativi sia sulla risoluzione dei problemi di utilizzo.</span></span></p>
                                          <a routerLink="/contattaci">Contattaci</a>
                                       </div>
                                       <div style="padding-left: 10px; padding-right: 10px"> &nbsp;</div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </section>


                     </div>
                  </div>
                  

<!--
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_frI9J4gzPlFv_">
                     <span id="p_56_INSTANCE_frI9J4gzPlFv"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_frI9J4gzPlFv">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable">Struttura del portale</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <p> <span >Il Portale <strong><span>SIRA</span>net </strong>espone le sue funzionalità strutturandosi, essenzialmente, in due macro-sezioni:</span></p>
                                       <ul>
                                          <li>
                                             <p> <span >una parte pubblica, destinata ai contenuti informativi, divulgativi, di presentazione del servizio e alle news.</span></p>
                                          </li>
                                          <li>
                                             <p> <span >una parte privata, per cui si necessita di esplicita autenticazione, che espone le funzionalità e i moduli tematici secondo la profilazione dell'utente.</span></p>
                                          </li>
                                       </ul>
                                       <p> <span >Per accedere alla sezione privata è necessario disporre di credenziali, alla specifica utenza è correlato un certo profilo, cui corrispondo le abilitazioni funzionali sui vari ambiti, catasti specifici e applicativi verticali, e sui moduli trasversali.</span></p>
                                       <p> &nbsp;</p>
                                       <table border="0" cellpadding="0" cellspacing="0" class="mceVisualAid" width="100%">
                                          <tbody>
                                             <tr>
                                                <td class="mceVisualAid"> <span><b>Navigazione sul Portale SIRAnet</b></span></td>
                                             </tr>
                                             <tr>
                                                <td class="mceVisualAid">
                                                   <blockquote>
                                                      <p> <span style="font-family: arial,helvetica,sans-serif;">Una sessione autenticata è facilmente riconoscibile dalla dock personalizzata, recante il nominativo associtato all'utenza, dove è possibile navigare alle due sezioni del Portale.</span></p>
                                                      <p> <span style="font-family: arial,helvetica,sans-serif;">L'interfaccia del portale è dinamica e può adattarsi collassando la testata grafica al fine di porre in evidenza il corpo pagina centrale, recante le informazioni contestuali.</span></p>
                                                   </blockquote>
                                                </td>
                                             </tr>
                                          </tbody>
                                       </table>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
-->

               </div>
            </div>


<!--column-2-->
            <div class="aui-w33 portlet-column portlet-3column-middle" id="column-2">
               <div class="portlet-dropzone portlet-column-content" id="layout-column_column-2">

                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_3W6nixDjxNBc_" style="display: none;">
                     <span id="p_56_INSTANCE_3W6nixDjxNBc"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_3W6nixDjxNBc">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable">Aree Tematiche SIRA</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <meta content="text/html; charset=UTF-8" http-equiv="Content-Type">
                                       <meta charset="utf-8">
                                       <title></title>
                                       <div class="siraSliderAccordion basic liteAccordion rounded stitch" id="sira" style="width: 500px; height: 250px;">
                                          <ol>
                                             <li class="slide">
                                                <h2 class="" style="height: 25px; left: 0px; width: 250px;"> <span style="border: 0; height: 25px;background-size: 250px 25px; background-image: url('assets/documents/d0da1090-88de-4440-9d67-4822846c13a0'); background-position: 0px;">Acque</span><b>1</b></h2>
                                                <div style="width: 319px; left: 0px; padding-left: 25px; background-image: url(&quot;assets/documents/015958f0-a4a8-4130-a95e-b26149de63f7&quot;); background-size: contain; background-repeat: no-repeat; background-position: center bottom;">
                                                   <h3 style="margin: 7px;"> Acque.<span style=" font-weight: normal;">&nbsp;</span></h3>
                                                   <p> &nbsp;</p>
                                                </div>
                                             </li>
                                             <li class="slide">
                                                <h2 style="height: 25px; left: 25px; width: 250px;" class=""> <span style="border: 0; height: 25px;background-size: 250px 25px; background-image: url('assets/documents/2db1cde2-64ce-4857-a1e3-90b7a4445e0d'); background-position: 0px;">Agenti Fisici</span><b>2</b></h2>
                                                <div style="width: 319px; left: 25px; padding-left: 25px; background-image: url(&quot;assets/documents/45d91e85-10b7-4148-aca1-d71bca96e3bf&quot;); background-size: contain; background-repeat: no-repeat; background-position: center bottom;">
                                                   <h3 style="margin: 7px;"> Agenti Fisici.</h3>
                                                </div>
                                             </li>
                                             <li class="slide">
                                                <h2 style="height: 25px; left: 50px; width: 250px;" class=""> <span style="border: 0; height: 25px;background-size: 250px 25px; background-image: url('assets/documents/e6b7c8ba-459c-4855-bc8f-993e14b95070'); background-position: 0px;">Aria</span><b>3</b></h2>
                                                <div style="width: 319px; left: 50px; padding-left: 25px; background-image: url(&quot;assets/documents/ef512e87-78b1-430d-bb21-79a264c64b2b&quot;); background-size: contain; background-repeat: no-repeat; background-position: center bottom;">
                                                   <h3 style="margin: 7px;"> Aria.</h3>
                                                </div>
                                             </li>
                                             <li class="slide">
                                                <h2 style="height: 25px; left: 75px; width: 250px;" class=""> <span style="border: 0; height: 25px;background-size: 250px 25px; background-image: url('assets/documents/a2085523-0497-4921-8af6-6ab68f29caf2'); background-position: 0px;">Conservazione Natura</span><b>4</b></h2>
                                                <div style="width: 319px; left: 75px; padding-left: 25px; background-image: url(&quot;assets/documents/791e884b-a551-48fd-a2a7-c55f06190eb1&quot;); background-size: contain; background-repeat: no-repeat; background-position: center bottom;">
                                                   <h3 style="margin: 7px;"> Conservazione Natura.</h3>
                                                </div>
                                             </li>
                                             <li class="slide">
                                                <h2 style="height: 25px; left: 100px; width: 250px;" class="selected"> <span style="border: 0; height: 25px;background-size: 250px 25px; background-image: url('assets/documents/81dc7612-a070-4b62-84b8-4d95ea7471ef'); background-position: 0px;">Energia</span><b>5</b></h2>
                                                <div style="width: 319px; left: 100px; padding-left: 25px; background-image: url(&quot;assets/documents/ea8f6387-a591-4664-9049-fb86c11a5e7b&quot;); background-size: contain; background-repeat: no-repeat; background-position: center bottom;">
                                                   <h3 style="margin: 7px;"> Energia.</h3>
                                                </div>
                                             </li>
                                             <li class="slide">
                                                <h2 style="height: 25px; left: 450px; width: 250px;" class=""> <span style="border: 0; height: 25px;background-size: 250px 25px; background-image: url('assets/documents/0dd8c0af-1aac-4afe-80ac-4662743f0ff6'); background-position: 0px;">Rifiuti</span><b>6</b></h2>
                                                <div style="width: 319px; left: 450px; padding-left: 25px; background-image: url(&quot;assets/documents/80546447-f630-463d-9f83-c1ea1a8b9b22&quot;); background-size: contain; background-repeat: no-repeat; background-position: center bottom;">
                                                   <h3 style="margin: 7px;"> Rifiuti.</h3>
                                                </div>
                                             </li>
                                             <li class="slide">
                                                <h2 style="height: 25px; left: 475px; width: 250px;" class=""> <span style="border: 0; height: 25px;background-size: 250px 25px; background-image: url('assets/documents/5b627142-37ea-4698-af6d-8a825fae97c8'); background-position: 0px;">Territorio</span><b>7</b></h2>
                                                <div style="width: 319px; left: 475px; padding-left: 25px; background-image: url(&quot;assets/documents/18af8a53-dc15-425e-9bb4-1eccb208a10e&quot;); background-size: contain; background-repeat: no-repeat; background-position: center bottom;">
                                                   <h3 style="margin: 7px;"> Territorio.</h3>
                                                </div>
                                             </li>
                                          </ol>
                                          <noscript> &lt;p&gt;Abilitare JavaScript per la piena funzionalità del portale.&lt;/p&gt; </noscript>
                                       </div>
                                    </div>
                                    <div class="entry-links"> </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>


                  <div class="sameheight portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_cag4mfzejIfx_">
                     <span id="p_56_INSTANCE_cag4mfzejIfx"></span> 
                     <div class="portlet-body">


                        <section class="portlet" id="portlet_56_INSTANCE_uEBYRuN5PJqd">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title">
                                             <span class="portlet-title-text">
                                                <a href="https://portal.sardegnasira.it/sistema-informativo-sira" title="Home" rel="home" class="toolbartitle toolbartitleHeight">
                                                   Cos'è il SIRA
                                                </a>
                                             </span>
                                          </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <div class="accordionfixedTab">
                                          <div class="accordionfixedTabContent">
                                             <p> 
                                                <span>
                                                   Il portale è stato creato per essere di supporto ai cittadini e alle imprese, migliorando la qualità dei servizi, fornendo uno strumento efficace ed efficiente che consente la gestione delle pratiche tramite un semplice accesso al portale, a partire dalla presentazione della richiesta sino alla sua conclusione con la conseguente dematerializzazione dei documenti e abbattimento dei tempi di svolgimento delle stesse. La digitalizzazione dei procedimenti, inoltre, darà luogo all’attivazione di un flusso di dati continuo e validato alla fonte che consentirà l’alimentazione del SIRA e l’aggiornamento automatico della comune base di conoscenza ambientale regionale, della quale i processi stessi rappresentano le principali fonti dell'informazione ambientale.
                                                   <!--
                                                      Il portale è stato creato per essere di supporto ai cittadini e alle imprese, migliorando la qualità dei servizi, fornendo uno strumento efficace ed efficiente che consente la gestione delle pratiche tramite un semplice accesso al portale, a partire dalla presentazione della richiesta sino alla sua conclusione con la conseguente dematerializzazione dei documenti e abbattimento dei tempi di svolgimento delle stesse.
                                                      La digitalizzazione dei procedimenti, inoltre, darà luogo all’attivazione di un flusso di dati continuo e validato alla fonte che consentirà l’alimentazione del SIRA e l’aggiornamento automatico della comune base di conoscenza ambientale regionale, della quale i processi stessi rappresentano le principali fonti dei dati, fornendo pertanto un efficace e validato strumento di diffusione dell'informazione ambientale sia ai diversi livelli della Pubblica Amministrazione, sia alle diverse categorie di soggetti privati.
                                                   -->
                                                </span>
                                             </p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </section>


                     </div>
                  </div>

                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_H6qf4dmlLgb2_">
                     <span id="p_56_INSTANCE_H6qf4dmlLgb2"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_H6qf4dmlLgb2">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text">Browser supportati</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <p>ll portale è ottimizzato per Mozilla Firefox e Google Chrome. Si consiglia di utilizzare le versioni più aggiornate di tali browser per una navigazione ottimale.</p>
                                       <p>Potrebbe essere opportuno, prima dell’accesso al sistema, svuotare la cache del browser per ridurre eventuali rallentamenti.</p>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>

                  <!--
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_dJRGlDSauz0v_">
                     <span id="p_56_INSTANCE_dJRGlDSauz0v"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_dJRGlDSauz0v">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable">Avviso</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <p> E' possibile navigare sul nuovo portale SIRA accedendo con le medesime credenziali del portale realizzato nell'ambito del primo stralcio.</p>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
                  -->

               </div>
            </div>

<!--column-3-->
            <div class="aui-w33 portlet-column portlet-3column-last" id="column-3">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-last" id="layout-column_column-3">



                  <!--Utenze estere-->
                  <div class="sameheight portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_H6qf4dmlLgb2_">
                     <span id="p_56_INSTANCE_H6qf4dmlLgb2"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_H6qf4dmlLgb2">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text">Utenze estere</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
									<div class="journal-content-article">
									   <p> <span >Per poter accedere al sistema è necessario dotarsi di credenziali <a href="https://www.spid.gov.it/richiedi-spid" target="_blank"><em><strong>SPID</strong></em></a>, <a href="https://tscns.regione.sardegna.it/" target="_blank"><em><strong>CNS</strong></em></a> o <a href="https://cartaidentita.interno.gov.it/argomenti/richiesta-cie" target="_blank"><em><strong>CIE</strong></em></a>. </span></p>
									   <p> <span >Nel caso sia necessario avere ulteriori informazioni è possibile contattare l'Help Desk al seguente indirizzo</span><span >:</span></p>
									   <p > <strong><a href="mailto:helpdesksira@regione.sardegna.it?subject=Accesso%20al%20SIRA%2C%20utenza%20estera&amp;body=Si%20richiede%20l'accesso%20al%20SIRA%20riservato%20alle%20utenze%20estere.%0A%0ANOME%3A%0ACOGNOME%3A%0AINDIRIZZO%3A%0A%0ASi%20allega%20copia%20fotostatica%20di%20un%20documento%20di%20riconoscimento%20valido" >helpdesksira@regione.sardegna.it</a></strong></p>
									</div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
<!--
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_ohRaUq2F10Qb_">
                     <span id="p_56_INSTANCE_ohRaUq2F10Qb"></span> 
                     <div class="portlet-body" id="aui_3_4_0_1_790">
                        <section class="portlet" id="portlet_56_INSTANCE_ohRaUq2F10Qb">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable">Informazioni</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content" id="aui_3_4_0_1_789">
                              <div class=" portlet-content-container" style="" id="aui_3_4_0_1_788">
                                 <div class="portlet-body" id="aui_3_4_0_1_787">
                                    <div class="journal-content-article" id="aui_3_4_0_1_786">
                                       <table border="0" cellpadding="0" cellspacing="0" class="mceVisualAid" width="100%" id="aui_3_4_0_1_785">
                                          <tbody id="aui_3_4_0_1_784">
                                             <tr>
                                                <td class="mceVisualAid"> <span><b>Maggiori informazioni su SIRAnet</b></span></td>
                                             </tr>
                                             <tr id="aui_3_4_0_1_783">
                                                <td class="mceVisualAid" id="aui_3_4_0_1_782">
                                                   <blockquote id="aui_3_4_0_1_781">
                                                      <p id="aui_3_4_0_1_780"> <span style="" id="aui_3_4_0_1_779">Naviga su&nbsp;<a routerLink="/chisiamo" id="aui_3_4_0_1_778">CHI SIAMO</a>&nbsp;per avere maggiori informazioni sul&nbsp;<em><strong><span>SIRA</span>net</strong></em></span></p>
                                                   </blockquote>
                                                </td>
                                             </tr>
                                          </tbody>
                                       </table>
                                       <table border="0" cellpadding="0" cellspacing="0" class="mceVisualAid" style="font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 10px; line-height: normal;" width="100%" id="aui_3_4_0_1_1492">
                                          <tbody id="aui_3_4_0_1_1491">
                                             <tr>
                                                <td class="mceVisualAid"> <span><b>Maggiori informazioni sui Servizi forniti dal SIRAnet</b></span></td>
                                             </tr>
                                             <tr id="aui_3_4_0_1_1490">
                                                <td class="mceVisualAid" id="aui_3_4_0_1_1489">
                                                   <blockquote id="aui_3_4_0_1_1488">
                                                      <p style="text-align: justify;"> <span style="">Per avere maggiori informazioni sugli ambiti trattati, naviga sulla sezione <a routerLink="/miinteressa">AREE TEMATICHE</a> e sulle sue sottosezioni.</span></p>
                                                      <p style="text-align: justify;" id="aui_3_4_0_1_1487"> <span style="" id="aui_3_4_0_1_1486">Per avere maggioni infomazioni sulle funzionalità e sui servizi espsti dal SIRAnet, navigare sulle sezioni&nbsp;<a routerLink="/servizionline" id="aui_3_4_0_1_1485">SERVIZI ONLINE</a>.</span></p>
                                                      <p style="text-align: justify;"> <span style="">Per avere maggiori informazioni sulla tipologia di utenze&nbsp;trattate, navigare sulla sezione <a routerLink="/iosono">IO SONO</a> e sulle&nbsp;sue sottosezioni.</span></p>
                                                   </blockquote>
                                                </td>
                                             </tr>
                                          </tbody>
                                       </table>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               -->

               </div>
            </div>
         </div>
      </div>
    </div>
    
</div>
